<template>
  <v-dialog v-model="dialogVisible" width="95%">
    <v-toolbar dark color="primary">
      <v-toolbar-title>Coin History</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeDialog()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card flat>
      <CoinHistory :key="componentKey" />
    </v-card>
  </v-dialog>
</template>

<script>
import CoinHistory from "@/components/CoinHistory.vue";

export default {
  name: "CoinHistoryDialog",
  components: {
    CoinHistory,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      componentKey: 0,
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.generateRandomKey();
      }
    },
  },
  methods: {
    generateRandomKey() {
      this.componentKey = Math.random();
    },
    closeDialog() {
      this.$emit("input", false);
    },
  },
};
</script>